<!--检验检测资质-->
<template>
  <div class="location-number">
    <seamless-scroll
      class="locaiton-scroll"
      :data="qualificationList"
      :class-option="classOption"
    >
      <div
        class="item-class"
        v-for="(item, index) in qualificationList"
        :key="index"
      >
        <div class="item-title">{{ item.type }}</div>
        <div class="item-content">{{ item.name }}</div>
        <div class="item-detail" @click="goPage(item.url)"></div>
      </div>
    </seamless-scroll>
  </div>
</template>

<script>
export default {
  props: {
    qualificationList: {
      type: Array,
      default: [],
    },
  },
  data() {
    return {
      classOption: {
        step: 0.5,
        limitMoveNum: 4,
      },
    };
  },
  methods: {
    goPage(url) {
      // window.location.href = url
      // window.open(url);
      const urlInfo = new URL(url);
      const locProtocol = window.location.protocol;
      let file = null;
      if (locProtocol.indexOf("https") >= 0) {
        file = `/tohttp${urlInfo.pathname}${urlInfo.search}`;
      } else {
        file = url;
      }
      window.open(file);
    },
  },
};
</script>
<style lang="scss" scoped>
@function vw($px) {
  @return ($px / 1920) * 100vw;
}
@function vh($px) {
  @return ($px / 1080) * 100vh;
}
@function fontSize($px) {
  @return 100vw * $px / 1920;
}

.location-number {
  height: 100%;
  font-family: Microsoft YaHei;
  .locaiton-scroll {
    height: 100%;
    overflow: hidden;
  }
  .item-class {
    position: relative;
    width: vw(314);
    // width: 100%;
    max-height: vh(83);
    padding: vh(6) vw(15);
    margin-top: vh(12);
    background-image: url("../../../../assets/images/governmentAffairs/vehicleIdentify/bg_list_jczz.png");
    background-size: 100% 100%;
    background-repeat: no-repeat;
    // padding-bottom: 18.47%; /* 假设背景图片的宽高比为16:9 */
    // // height: 0; /* 设置高度为0，让padding-bottom控制高度 */
    font-size: fontSize(14);
    color: #deffe9;
    .item-title {
      padding-bottom: vh(4);
      font-weight: bold;
      font-style: italic;
      background: linear-gradient(180deg, #ffffff 35.009765625%, #bdffcc 70%);
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
      border-bottom: 1px dashed #0d7330;
    }
    .item-content {
      width: vw(246);
      padding-top: vh(4);
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 2;
      // white-space: nowrap; /* 防止换行 */
      // overflow: hidden; /* 隐藏超出部分 */
      // text-overflow: ellipsis; /* 显示省略号 */
    }
    .item-detail {
      position: absolute;
      right: 0;
      bottom: 0;
      width: vw(40);
      height: vh(20);
      background-image: url("../../../../assets/images/governmentAffairs/vehicleIdentify/btn_more.png");
      background-size: 100%;
      background-repeat: no-repeat;
      cursor: pointer;
    }
  }
}
</style>
